const defaultIndexHtmlTitle = 'Upright Platform';
export default defaultIndexHtmlTitle;
